import { Component } from '@angular/core';
import { CampaignSettingsAbstractComponent } from '../campaign-settings-abstract.component';
import { AlertService, CampaignService, LoaderService, SideNavService, UserService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CampaignSection, CampaignStatus, User } from '../../_models';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as moment from 'moment-timezone';

@Component({
  templateUrl: './campaign-general.component.html',
  styleUrls: ['../campaign-section.scss', './campaign-general.component.scss'],
})
export class CampaignGeneralComponent extends CampaignSettingsAbstractComponent {
  public section = CampaignSection.General;
  timezones: string[] = [];
  campaignStatus = CampaignStatus;
  user: User;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected sideNav: SideNavService,
    protected modalService: NgxSmartModalService,
    protected loaderService: LoaderService,
    protected userService: UserService
  ) {
    super(router, location, route, campaignService, sideNav, alertService, loaderService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      status: [CampaignStatus.Active, [Validators.required]],
      currency: ['USD', [Validators.required]],
      timezone: [moment.tz.guess(), [Validators.required]],
    });
    super.ngOnInit();
    this.timezones = moment.tz.names();
    this.fetchUser();
  }

  fetchUser() {
    this.userService.getCurrent().subscribe((user: User) => {
      this.user = user;
    });
  }

  isCampaignInactive() {
    return this.campaign.status === CampaignStatus.Inactive;
  }

  isCampaignEnabled() {
    return this.form.get('status').value === CampaignStatus.Active;
  }

  enableCampaign(event) {
    if (!this.isCampaignInactive()) {
      const action = event.target.checked ? 'enable' : 'disable';
      const message = `Are you sure you want to ${action} this brand?`;

      if (window.confirm(message)) {
        this.form.get('status').setValue(event.target.checked ? CampaignStatus.Active : CampaignStatus.Disabled);
      }
    }
  }

  openDetailsModal() {
    this.modalService.getModal('brandDetailsPopup').open();
  }

  getCampaignStatus() {
    const status = this.form.get('status').value;
    const statusMap = {
      [CampaignStatus.Active]: 'Enabled',
      [CampaignStatus.Disabled]: 'Disabled',
      [CampaignStatus.Inactive]: 'Inactive',
    };
    return statusMap[status];
  }

  onSaveComplete(data) {
    super.onSaveComplete(data);
    this.modalService.getModal('brandDetailsPopup').close();
    let currentCampaign = this.campaignService.getCurrentCampaign();
    currentCampaign['name'] = data['name'];
    currentCampaign['display_name'] = data['display_name'];
    this.campaignService.currentCampaignUpdated(currentCampaign);
  }

  get isAdmin(): boolean {
    return this.user && this.user.is_staff;
  }
}
